import { render } from "./YourDetailsNOC.vue?vue&type=template&id=c4fc3050&scoped=true"
import script from "./YourDetailsNOC.vue?vue&type=script&lang=js"
export * from "./YourDetailsNOC.vue?vue&type=script&lang=js"

import "./YourDetailsNOC.vue?vue&type=style&index=0&id=c4fc3050&lang=scss"
import "./YourDetailsNOC.vue?vue&type=style&index=1&id=c4fc3050&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fc3050"]])

export default __exports__